export const couponConstants = {
    CREATE_COUPON_REQUEST: 'CREATE_COUPON_REQUEST',
    CREATE_COUPON_SUCCESS: 'CREATE_COUPON_SUCCESS',
    CREATE_COUPON_FAILURE: 'CREATE_COUPON_FAILURE'
}


// WEBPACK FOOTER //
// ./src/constants/coupon.js